export const SET_REFERRAL = "SET_REFERRAL";
export const UPDATE_REFERRAL = "UPDATE_REFERRAL";
export const MSG = "MSG";
export const CLEAR_MSG = "CLEAR_MSG";
